
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

var $ce01535ccd86e19d$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('5Dpmu'), JSON.parse("[\"5Dpmu\",\"404.96f40934.js\",\"9BftR\",\"create-payload.42c910ce.js\",\"lM1L3\",\"create-post-interaction-log-payload.03ec4be3.js\",\"knVBe\",\"segment-highlight.bcd1bce2.js\",\"hyT2F\",\"dropdown-import.b5509b84.js\",\"PtGJI\",\"dropdown-import.f3a7378e.js\",\"b8kt6\",\"esm.42ab601e.js\",\"ak5E0\",\"dev.87b06fdf.js\",\"1UKEw\",\"view.1e4fc557.js\",\"7Q4ht\",\"view.ce6f9bcb.js\",\"gFcxC\",\"view.bc0cbe71.js\",\"9WEDO\",\"view.0df8b2a0.js\",\"h62UC\",\"language-selector.79d8f15c.js\",\"evwwy\",\"language-selector.517c7881.js\",\"8QhO3\",\"app-switcher.9a7173a7.js\",\"32DAP\",\"segment-highlight.b44984c6.js\",\"78ssC\",\"robot-error.909146c5.js\",\"3sxEO\",\"atlassian-switcher.65e1d3ec.js\",\"jj9yd\",\"cs.7ee01efc.js\",\"1JUTQ\",\"da.37403e63.js\",\"eJY2b\",\"de.689eee4b.js\",\"boveV\",\"en_GB.3cae2b3a.js\",\"jhzZD\",\"en_ZZ.2dc68c5f.js\",\"3ggHc\",\"en.9b2e99cc.js\",\"6K3IJ\",\"es.f8e8cfc7.js\",\"2Egxk\",\"et.acafa8d9.js\",\"jrBrI\",\"fi.e3750a74.js\",\"ke1AQ\",\"fr.4d353dda.js\",\"6THQG\",\"hu.abe9a133.js\",\"h42BO\",\"is.cd96babc.js\",\"7ineD\",\"it.42fc230d.js\",\"9sO7N\",\"ja.7732d822.js\",\"lnoMs\",\"ko.b8f8d464.js\",\"kVmkq\",\"nb.4407229c.js\",\"3DibN\",\"nl.9c4c305f.js\",\"9Uhkl\",\"pl.f1a90dd9.js\",\"8mFDW\",\"pt_BR.ac9f36ee.js\",\"7GlIc\",\"pt_PT.78a0c0fe.js\",\"dvqQm\",\"ro.54632d07.js\",\"3ZtCq\",\"ru.222beddf.js\",\"dcHjQ\",\"sk.d8a86b46.js\",\"ajnS3\",\"sv.92a2284c.js\",\"bcnO6\",\"th.c40b5e02.js\",\"hL42d\",\"tr.c9750cba.js\",\"dr0Vi\",\"uk.3be6072a.js\",\"kopRi\",\"vi.dad9bc8d.js\",\"dFq33\",\"zh_TW.ac0f37db.js\",\"jMVsQ\",\"zh.e40660f9.js\",\"iJGev\",\"jira-switcher.55fe6b8f.js\",\"3s2Ul\",\"jira-switcher.cb8d34ed.js\",\"dRtpj\",\"animation-illustration.4f7d7e85.js\",\"aitqo\",\"animation-illustration.a9145d1a.js\",\"1az2W\",\"jira-switcher.685c2407.js\",\"dvcYi\",\"jira-switcher.runtime.7f13662e.js\",\"dvcYi\",\"jira-switcher.runtime.7f13662e.js\",\"2BPdX\",\"confluence-switcher.13a3509e.js\",\"1Cf3b\",\"generic-switcher.b3db84f3.js\",\"iTD5B\",\"custom-theme.9098f716.js\",\"42hNR\",\"atlassian-light.7e703631.js\",\"d7Q1x\",\"atlassian-light-future.b88415fa.js\",\"axYAg\",\"atlassian-light-increased-contrast.38438940.js\",\"dxnrk\",\"atlassian-dark.18717d1d.js\",\"gEsP8\",\"atlassian-dark-future.9d842f9c.js\",\"10pgT\",\"atlassian-dark-increased-contrast.9ac79727.js\",\"fi0UL\",\"atlassian-legacy-light.a95d3be3.js\",\"f9gs0\",\"atlassian-legacy-dark.221fc17c.js\",\"6o2ay\",\"atlassian-spacing.faf80770.js\",\"fytov\",\"atlassian-typography.4692dec9.js\",\"adIJD\",\"atlassian-shape.b5f45e32.js\"]"));


//# sourceMappingURL=404.runtime.15c9c90e.js.map
